import moment from "moment";

export const formatDate = (date, type) => {
  const parsedDate = new Date(date);

  const day = String(parsedDate.getDate()).padStart(2, "0");
  const month = String(parsedDate.getMonth() + 1).padStart(2, "0");
  const year = parsedDate.getFullYear();

  switch (type) {
    case 1:
      return `${day}-${month}-${year}`;

    case 2:
      return `${month} ${day}, ${year}`;

    case 3:
      return `${day}/${month}/${year}`;

    case 4:
      return `${day}/${month}/${year}`;

    case 5:
      return `${year}-${month}-${day}`;

    default:
      return `${day}/${month}/${year}`;
  }
};

export const downloadHandler = (fileType, reportName) => {
  const params = new URLSearchParams({
    fileType,
    reportName,
  });

  window.location.href = `/api/unit-prices/download?${params.toString()}`;
};

export const historicalDownloadHandler = (
  fileType,
  reportName,
  fund,
  fromDate,
  toDate
) => {
  const fromParameter = moment(fromDate, "DD/MM/YYYY", true);
  const toParameter = moment(toDate, "DD/MM/YYYY", true);

  const params = new URLSearchParams({
    fileType,
    reportName,
    fund,
    fromDate: fromParameter.format("DD-MM-YYYY"),
    toDate: toParameter.format("DD-MM-YYYY"),
  });

  window.location.href = `/api/historical-unit-prices/download?${params.toString()}`;
};

export const checkNumberOnly = (value) => /^[0-9]*$/.test(value);